import { defineComponent as _defineComponent } from 'vue'
import { JobJson } from '@/models/types/job-json'
import { useStore } from 'vuex-composition-helpers'
import { computed } from 'vue'
import Division from '@/models/division'
import { BusinessUnit } from '@/models/business-unit'
import Company from '@/models/company'


export default /*#__PURE__*/_defineComponent({
  __name: 'Division',
  props: {
    value: null,
    job: null
  },
  setup(__props: any) {

const props = __props as {
  value?: string | null
  job: JobJson
}


const store = useStore()
const getDivisionByUuid = computed<
  (uuid: string) => Division | null | undefined
>(() => store.getters['divisions/getByUuid'])
const divisionName = computed(
  () => getDivisionByUuid.value(props.value ?? '')?.name
)
const getBusinessUnitById = computed<
  (uuid: string) => BusinessUnit | null | undefined
>(() => store.getters['businessUnits/getBusinessUnitById'])
const hub = computed(() => getBusinessUnitById.value(props.job.hub_id))
const getCompanyByOrganizationId = computed<
  (uuid: string) => Company | null | undefined
>(() => store.getters['companies/getByOrganizationId'])
const companyShortCode = computed(() => {
  const result = getCompanyByOrganizationId.value(
    hub.value?.ownerId ?? ''
  )?.shortCode
  if (result) {
    return ` (${result})`
  }
  return ''
})

return { __sfc: true,props, store, getDivisionByUuid, divisionName, getBusinessUnitById, hub, getCompanyByOrganizationId, companyShortCode }
}

})